import Vue from "vue"

import validate from "~/directives/validate"

export type ValidationFunction = () => Promise<boolean>
export type ValidityObject = { [key: string]: boolean }

export default Vue.extend({
  directives: { validate },
  data() {
    return {
      validity: {} as ValidityObject,
    }
  },
  methods: {
    resetValidation() {
      for (const key in this.validity) this.validity[key] = true
    },
    async validateSilent() {
      const out = {} as ValidityObject

      Object.keys(this.validity).forEach(async (key: keyof ValidityObject) => {
        //@ts-ignore
        const fn: ValidationFunction | undefined = this["validate_" + key]

        if (typeof fn === "function") out[key] = await this.validateSingle(fn)
      })
      return out
    },
    validateSingle(fn: ValidationFunction): Promise<boolean> {
      return new Promise(async (resolve) => {
        try {
          resolve((await fn()) === true)
        } catch (error) {
          //@ts-ignore
          this.$sentry.captureException(error)
          console.error(error)
          resolve(false)
        }
      })
    },
    validateAll() {
      return new Promise(async (resolve, reject) => {
        let out = true
        for (const key in this.validity) {
          //@ts-ignore
          const fn: ValidationFunction | undefined = this["validate_" + key]
          if (typeof fn === "function") {
            this.validity[key] = await this.validateSingle(fn)
            out = out && this.validity[key]
            this.$nextTick(() => {
              this.$emit(`validating_${key}`)
            })
          }
        }
        if (out) resolve(true)
        else reject(false)
      })
    },
    /**
     * Deprecated, please use validateAll. TODO: replace this method everywhere it is used.
     *
     * @param {number} start -
     * @param {number} end -
     * @returns {boolean} Validation status.
     */
    validate(start = 0, end: number): boolean {
      let prog = 0

      for (const key in this.validity) {
        //@ts-ignore
        const fn: () => boolean = this["validate_" + key]

        if (typeof fn === "function") {
          if (
            typeof start !== "undefined" ||
            (typeof start === "number" && prog >= start)
          ) {
            this.validity[key] = fn()

            if (this.validity[key] !== true) return false
          }
        }
        prog++
        if (typeof end === "number" && prog > end) break
      }
      return true
    },
    checkEmail(email: string) {
      const standardized = email.trim().toLowerCase()

      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      return standardized.match(re) !== null
    },
    checkUrl(url: string) {
      return (
        url.match(
          /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.\D]+$/gi
        ) !== null
      )
    },
    checkPassword(password: string) {
      return typeof password === "string" && password.length >= 8
    },
  },
})
